// extracted by mini-css-extract-plugin
export default {"clientFeedback":"clientFeedback_clientFeedback__eYBTs"};